<template>
    <div>
        <mu-chip showDelete>
            <mu-avatar :size="32" icon="face" /> icon avatar chip
        </mu-chip>
    </div>
</template>
<script>
export default {
    name: 'chip'
}
</script>



// WEBPACK FOOTER //
// chip.vue?861b7572